Pixlee.module('Behaviors', function(Behaviors, App, Backbone, Marionette, $) {

    Behaviors.SocialConnect = Marionette.Behavior.extend({
        initialize: function(){
            var _this = this;
            var collection = App.widget.currentView.collection;
            _this.defaultUrl = collection.url();
            collection.on('sync', function (collection, resp){
                _this.getLoginStatus();
            });
        },
        events: {
            'click #facebook_login': function() {
                var _this = this;
                App.execute("facebook:login:photos", function(social_login) {
                    _this.processCollection('facebook', social_login);
                });
            },
            'click #instagram_login': function() {
                var _this = this;
                App.execute("instagram:login:photos", function(social_login) {
                    _this.processCollection('instagram', social_login);
                });
            },
            'click #twitter_login': function() {
                var _this = this;
                App.execute("twitter:login:photos", function(social_login) {
                    _this.processCollection('twitter', social_login);
                });
            }
        },
        processCollection: function(platform, social_login){
            var collection = App.widget.currentView.collection;
            collection.reset();
            collection.fetch();
        },
        getLoginStatus: function(){
        
        }
    });

});